"use client";

import type { AboutData } from "@/services/public.service";
import { useLocale } from "next-intl";
import Link from "next/link";

function Icon({ name, className = "" }: { name: string; className?: string }) {
  return <span className={`material-symbols-outlined ${className}`}>{name}</span>;
}

export default function AboutCTA({ about, isAr }: { about: AboutData; isAr: boolean }) {
  const locale = useLocale();
  const cta = about.cta;
  if (!cta) return null;

  const title = isAr ? cta.title.ar : cta.title.en;
  const subtitle = isAr ? cta.subtitle.ar : cta.subtitle.en;
  const label = isAr ? cta.buttonLabel.ar : cta.buttonLabel.en;
  if (!title && !label) return null;

  // Normalize link → keep external as-is, prefix internal with locale.
  const raw = cta.buttonLink || "/list-property";
  const href = raw.startsWith("http") ? raw : `/${locale}${raw.startsWith("/") ? raw : `/${raw}`}`;

  return (
    <section className="container mx-auto px-6 py-16 md:py-20">
      <div className="relative overflow-hidden rounded-3xl bg-clay-600 text-white text-center px-6 py-16 md:py-20">
        <div
          className="absolute inset-0 opacity-10 pointer-events-none"
          style={{ backgroundImage: "radial-gradient(circle at 15% 25%, #fff 1px, transparent 1px)", backgroundSize: "30px 30px" }}
        />
        <div className="relative">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">{title}</h2>
          {subtitle && <p className="text-white/85 max-w-2xl mx-auto mb-8 leading-relaxed">{subtitle}</p>}
          {label && (
            <Link
              href={href}
              className="inline-flex items-center gap-2 rounded-full bg-white text-clay-600 px-8 py-3.5 font-bold hover:bg-clay-50 transition-colors"
            >
              {label}
              <Icon name={isAr ? "arrow_back" : "arrow_forward"} className="text-[20px]" />
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
